import 'intersection-observer';
import 'nodelist-foreach-polyfill'

document.addEventListener('DOMContentLoaded', (event) => {

	const fadeIn = function ( target ) {
		target.classList.add('a-fadein__done');
		observer.unobserve(target);
	}

	const doWhenIntersect = (entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				fadeIn(entry.target);
			}
		});
	};

	const options = {
		rootMargin: '0px 0px',
	};

	const observer = new IntersectionObserver(doWhenIntersect, options);
	const animationObjects = document.querySelectorAll(".a-fadein, .a-fadein__up, .a-fadein__left, .a-fadein__right");

	animationObjects.forEach(animationObject => {
		observer.observe(animationObject);
	});
});
